<template>
  <div class="writing-system-view">
    <div class="column column-left"></div>
    <div class="column column-center"> 
      <h1 id="title">The Japanese Writing System</h1>
      <div id="intro">
        When first learning a language one of the first things you learn is the 
        alphabet. The Japanese don't really have an alphabet they way latin script 
        based langauages do. They developed their own phonetic alphabet which describes 
        their language. The writing systems are called Hiragana and Katakana referred to collectively as 
        kana.  
      </div>
      <div class="writing-system-container">
        <p class="writing-system-main-text">
          Here is a graph containing some of the basic kana characters.
          Hover over each of symbols so see what the char sounds like in english and click 
          the toggle on the right to swap between them. You can see how they are similiar which
          is a good way to memorize both.
        </p>
      </div>
      <WritingSystemChart chart="base-hiragana" style="margin-top: 60px;"/>
      <div class="writing-system-container">
        <p class="writing-system-main-text" style="margin-top: 50px;">
          After looking at the chart you will notice that the chars are organized in a certain way.
          Each column belongs to a certain ending. The left most column is based on chars with 
          the ending a, pronounced ah. So therefore you get a, ka, sa, ta, ha, ect. Basically like 
          letters but they are made up of two sounds. These chars are the building blocks of Japanese 
          so make sure to commit these to memory. A good way to do it while learning is create your 
          own story for remembering them. Our favorite instance of this is hiragana む / mu. This Hiragana looks like
          a cow and it sounds like "moo" making it very easy to remember.  
        </p>
      </div>
      <div class="writing-system-container">
        <p class="writing-system-main-text">
          Since you have probaly already mastered the base kata there is a set of 
          special kana that are conjugations of the previous. The k's go 
          to g's and t's to d's. There are some irregulars like じ / ji instead 
          of zi but for the most part there is a pattern.
        </p>
      </div>
      <WritingSystemChart chart="dakuten-hiragana" style="margin-top: 60px;"/>
      <div class="writing-system-container" style="margin-top: 60px;">
        <p class="writing-system-main-text">
          The next thing to learn is what we refer to as combo kana. These are kana 
          whose sound changes depending on the kana around them.
        </p>
      </div>
      <WritingSystemChart chart="combo-hiragana" style="margin-top: 60px;"/>
      <div class="writing-system-container" style="margin-top: 60px;">
        <p class="writing-system-main-text">
          For these type of kata there is a little や / ヤ / ya, ゆ / ユ / yu, or よ / ヨ / yo next to the first kana. 
          When this happens the sound at the end of the orginal kana is dropped and the sound of the second
          kana is added on. So in the case of hiragana じ / ji plus a よ / yo the the 'i' is dropped and is replaced
          with yo giving us じょ / jyo pronounced like Joe. Also hiragana and katakana don't mix. They both 
          make up seperate words and are never used to make up the same word.  
        </p>
      </div>
      <div id="conclusion">
        Kana is the the basis of reading and writing Japanese. These chars allow for a world of 
        possibilities to open up, you will be able to read some signs and places just knowing this 
        char set. However, a journey starts with a single step and this is the just the first one.
      </div>
    </div>
    <div class="column column-right">
    </div>
    </div>
</template>

<script>

import WritingSystemChart from '../components/WritingSystemChart.vue';
import { useHead } from '@vueuse/head'

export default {
  name: "WritingSystem",
  setup() {
    useHead({
      title: 'The Japanese Writing System - An indepth view of the Japanese writing system and how to use it',
      meta: [
        {
          name: 'description',
          content: 'hiragana chart, katakana chart, hiragana and katakana, japanese writing system, learn japanese, learn japanese online, learn japanese reading, learn japanese writing, how to learn japanese, interactive kana chart'
        }
      ]
    })

    // ...rest of your existing setup() code, if any
  },
  components: {
    WritingSystemChart
  },
  data() {
  },
  methods: {
  
  },
};
</script>

<style scoped>

#conclusion {
  margin-top: 50px;
  margin-bottom: 100px;
}

.writing-system-main-text {
  margin-top: 30px;
}

.writing-system-container {
  margin-top: 30px;
}

#title {
  margin-top: 50px;
}

#intro {
  margin-top: 30px;
}

.writing-system-view {
  text-align: left;
  font-family: Arial, sans-serif;
  display: flex;
  width: 100%;
}

/* Specific column widths */
.column-left {
  width: 15%; /* Left column occupies 20% */
  /* background-writing-system:  #000080; */
}

.column-center {
  width: 70%; /* Center column occupies 60% */
  padding: 0 50px 0px 50px
}

.column-right {
  width: 15%; /* Right column occupies 20% */
  /* background-writing-system:  #000080; */
}

</style>
